export default "__VITE_ASSET__X1L5Jlfz__"